"use strict";

(() => {
  const loading = document.querySelector("[data-loading]");

  if (loading) {
    const root = document.documentElement;
    const reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

    const startFv = () => {
      document.dispatchEvent(new CustomEvent("theme:fvStart"));
    };

    const unlock = () => {
      root.classList.remove("is-loading");
      root.style.overflow = "";
      document.body.style.overflow = "";
    };

    if (root.classList.contains("is-loaded")) {
      loading.remove();
      requestAnimationFrame(startFv);
    } else {
      try {
        sessionStorage.setItem("themeLoaded", "1");
      } catch (e) {}

      const LOGO_START_DELAY = reduce ? 0 : 700;
      const LOGO_FADE_DURATION = reduce ? 300 : 1200;
      const LINE_START_DELAY = reduce ? 300 : LOGO_FADE_DURATION - 900;
      const LINE_DELAY = LOGO_START_DELAY + LINE_START_DELAY;
      const LINE_DURATION = 3000;
      const FADE_DURATION = reduce ? 300 : 1100;
      const holdBeforeFade = reduce ? 400 : LINE_DELAY + LINE_DURATION;

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          window.setTimeout(() => {
            loading.classList.add("is-logoFade");
          }, LOGO_START_DELAY);
        });
      });

      window.setTimeout(() => {
        loading.classList.add("is-leaving");
        startFv();

        window.setTimeout(() => {
          unlock();
          loading.remove();
        }, FADE_DURATION);
      }, holdBeforeFade);
    }
  }
})();
